import store from '@/store';
import config from './config'

const wsUrl = config.wsUrl;

let socket = null;
let isConnect = false; // 连接状态
let reConnectNum = 0;// 重连次数
const messageList = {}; // 获取消息的回调对象存储
const heartCheck = {
  heart: JSON.stringify({"key":"20250108092140-8809d211f3be44c2b","act":"Pong"}), // 心跳包
  timeout: 60 * 1000, // 每段时间发送一次心跳包
  heartbeat: null, // 延时发送消息对象(启动心跳新建这个对象，收到消息后重置对象)
  start() {
    this.heartbeat = setInterval(() => {
      if (isConnect) {
        socket.send(this.heart);
      } else {
        this.clear();
      }
    }, this.timeout);
  },
  reset() {
    clearInterval(this.heartbeat);
    this.start();
  },
  clear() {
    clearInterval(this.heartbeat);
  },
};
// 初始化
function init(id) {
  !isConnect && connectSocket(id);
  socket.onopen = () => {
    console.log('链接建立');
    socket.send(heartCheck.heart);
    heartCheck.start();
  };
  socket.addEventListener('message', (e) => {
    console.log('收到消息', e.data);
    const message = JSON.parse(e.data);
    messageList.writeOff(message);
  });
  socket.onerror = () => {
    console.log('链接错误');
    isConnect = false;
    reconnectSocket();
  };
  socket.onclose = (e) => {
    console.log('链接关闭', e);
    isConnect = false;
    if (e.code === 1006) {
      reconnectSocket();
    }
  };
}

// 连接
function connectSocket(id) {
  try {
    isConnect = true;
    // let protocol = 'ws';
    // if (window.location.protocol === 'https:') {
    //   protocol = 'wss';
    // }
    console.log('链接中',id);
    let url = '';
    if(id){
      url = `${wsUrl}/ws/${id}`;
    }else{
      let storeId = JSON.parse(localStorage.getItem('user')).storeid
      url = `${wsUrl}/ws/${storeId}`;
    }
    socket = new WebSocket(url);
  } catch {
    console.log('连接错误');
  }
}

// 主动关闭socke链接
function closeSocket() {
  socket && socket.close();
  heartCheck.clear();
  isConnect = false;
  reConnectNum = 0;
}

// 重连
function reconnectSocket() {
  if (isConnect) {
    return;
  }
  heartCheck.clear();
  if (reConnectNum <= 10) {
    connectSocket();
    reConnectNum += 1;
  } else {
    console.log('重连10次');
  }
}

// 获取服务端返回信息
function getSocketMessage(name, cb) {
  messageList[name] = cb;
}

export default {
  init,
  closeSocket,
  getSocketMessage,
};
